var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogleColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.32 14.2916C26.32 13.3816 26.2383 12.5066 26.0867 11.6666H14V16.6366H20.9067C20.6033 18.235 19.6933 19.5883 18.3283 20.4983V23.73H22.4933C24.92 21.49 26.32 18.2 26.32 14.2916Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 26.8333C17.4646 26.8333 20.3696 25.69 22.493 23.73L18.328 20.4983C17.1846 21.2683 15.7263 21.735 13.9996 21.735C10.663 21.735 7.82797 19.4833 6.81297 16.45H2.54297V19.7633C4.65464 23.9516 8.98297 26.8333 13.9996 26.8333Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81268 16.4383C6.55602 15.6683 6.40435 14.8516 6.40435 14C6.40435 13.1483 6.55602 12.3316 6.81268 11.5616V8.24829H2.54268C1.66768 9.97496 1.16602 11.9233 1.16602 14C1.16602 16.0766 1.66768 18.025 2.54268 19.7516L5.86768 17.1616L6.81268 16.4383Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 6.27675C15.8896 6.27675 17.5696 6.93008 18.9113 8.19008L22.5863 4.51508C20.358 2.43841 17.4646 1.16675 13.9996 1.16675C8.98297 1.16675 4.65464 4.04841 2.54297 8.24841L6.81297 11.5617C7.82797 8.52841 10.663 6.27675 13.9996 6.27675Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleColor);
export default __webpack_public_path__ + "static/media/icon_google_color.4f489a98ea1f3cac1fb01b0f8bc59e92.svg";
export { ForwardRef as ReactComponent };